module.exports = __webpack_public_path__ + "static/media/design-tools.0afb8cb0.svg";